var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 0.428711C3.35795 0.428711 0 4.26637 0 9.00014C0 13.7339 3.35795 17.5716 7.5 17.5716C11.642 17.5716 15 13.7339 15 9.00014C15 4.26637 11.642 0.428711 7.5 0.428711ZM8.18182 12.117C8.18182 12.3237 8.10998 12.5219 7.98212 12.668C7.85425 12.8141 7.68083 12.8962 7.5 12.8962C7.31917 12.8962 7.14575 12.8141 7.01788 12.668C6.89002 12.5219 6.81818 12.3237 6.81818 12.117V9.77936H4.77273C4.5919 9.77936 4.41847 9.69726 4.29061 9.55113C4.16274 9.405 4.09091 9.2068 4.09091 9.00014C4.09091 8.79348 4.16274 8.59528 4.29061 8.44915C4.41847 8.30301 4.5919 8.22092 4.77273 8.22092H6.81818V5.88326C6.81818 5.67659 6.89002 5.4784 7.01788 5.33226C7.14575 5.18613 7.31917 5.10404 7.5 5.10404C7.68083 5.10404 7.85425 5.18613 7.98212 5.33226C8.10998 5.4784 8.18182 5.67659 8.18182 5.88326V8.22092H10.2273C10.4081 8.22092 10.5815 8.30301 10.7094 8.44915C10.8373 8.59528 10.9091 8.79348 10.9091 9.00014C10.9091 9.2068 10.8373 9.405 10.7094 9.55113C10.5815 9.69726 10.4081 9.77936 10.2273 9.77936H8.18182V12.117Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlus);
export default __webpack_public_path__ + "static/media/IconPlus.220c2274365ebbe5121acc522a1d9b93.svg";
export { ForwardRef as ReactComponent };